import { render, staticRenderFns } from "./VideoClaimsList.vue?vue&type=template&id=9ac29eea&scoped=true"
import script from "./VideoClaimsList.vue?vue&type=script&lang=js"
export * from "./VideoClaimsList.vue?vue&type=script&lang=js"
import style0 from "./VideoClaimsList.vue?vue&type=style&index=0&id=9ac29eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac29eea",
  null
  
)

export default component.exports